import styled from "styled-components";

export default styled.div`
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: ${props => `${props.slideMenu} 1fr`};
  grid-template-areas: "menu dashboard";
`;
